const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL']

export function selectValidVariants (productType, variants, ...args) {
  let selectable = []
  switch (productType) {
    case 'canvas wall art':
      selectable = selectCanvasWallArtVariants(variants, ...args)
      break
    default:
      console.warn('No variant selection function for product type', productType)
  }
  if (selectable.length === 0) {
    console.warn('No variants found for product type', productType)
  }
  return selectable
}

function selectCanvasWallArtVariants (variants, aspectRatio) {
  return variants.filter(v => {
    const sizeTitle = v.options?.size || v.title
    const match = sizeTitle.match(/(\d+)[^\d]+(\d+)/)
    if (match) {
      const w = parseInt(match[1])
      const h = parseInt(match[2])
      const ratio = getBaseRatio(w, h)
      return ratio === aspectRatio
    }
    return false
  })
}

// Returns sizes available in ALL selected colors, sorted by standard size order.
export function getAvailableSizes (variants, selectedColors) {
  if (!selectedColors || selectedColors.length === 0) {
    const sizes = new Set(variants.map(v => v.options?.size).filter(Boolean))
    return sortSizes([...sizes])
  }
  const sizesByColor = selectedColors.map(color =>
    new Set(
      variants
        .filter(v => v.options?.color?.toLowerCase() === color.toLowerCase())
        .map(v => v.options?.size)
        .filter(Boolean)
    )
  )
  if (sizesByColor.length === 0) return []
  const intersection = [...sizesByColor[0]].filter(size => sizesByColor.every(s => s.has(size)))
  return sortSizes(intersection)
}

// Returns variant IDs matching any of the given sizes AND any of the selected colors.
export function getVariantIdsForSizes (variants, sizes, selectedColors) {
  const sizeSet = new Set(sizes)
  return variants
    .filter(v => {
      const size = v.options?.size
      const color = v.options?.color
      const sizeMatch = sizeSet.has(size)
      const colorMatch = !selectedColors || selectedColors.length === 0 ||
        selectedColors.some(c => c.toLowerCase() === color?.toLowerCase())
      return sizeMatch && colorMatch
    })
    .map(v => v.id)
}

// Returns the set of unique sizes represented in the given variant IDs.
export function getSizesFromVariantIds (variants, variantIds) {
  const idSet = new Set(variantIds)
  const sizes = new Set(variants.filter(v => idSet.has(v.id)).map(v => v.options?.size).filter(Boolean))
  return sortSizes([...sizes])
}

function sortSizes (sizes) {
  return sizes.slice().sort((a, b) => {
    const ai = SIZE_ORDER.indexOf(a)
    const bi = SIZE_ORDER.indexOf(b)
    if (ai === -1 && bi === -1) return a.localeCompare(b)
    if (ai === -1) return 1
    if (bi === -1) return -1
    return ai - bi
  })
}

export const getGCD = (a, b) => {
  a = Math.abs(a)
  b = Math.abs(b)
  while (b) {
    a %= b;
    [a, b] = [b, a]
  }
  return a
}

export const getBaseRatio = (num1, num2) => {
  if (num1 === 0 || num2 === 0) return `${num1}:${num2}`

  const common = getGCD(num1, num2)
  return `${num1 / common}:${num2 / common}`
}
